<template>
  <div>
    <div>用户ID  订单ID  手机号  邮箱地址</div>
   <div class="searchBox">
    <div class="searchLeft">
      <el-input
        size="medium"
        v-model="searchForm.searchContent"
        placeholder=""
        @keyup.enter.native="getTableList"
      ></el-input>
      <el-select
        size="medium"
        v-model="searchForm.miningStatus"
        placeholder="请选择状态"
        @change="getTableList"
        clearable 
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
      <!-- <el-input size="medium" v-model="searchForm.key_words" placeholder="请输入搜索内容"  @keyup.enter.native="getTableList"></el-input> -->
      <el-date-picker
       size="medium"
        v-model="searchForm.startTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsStart"
        placeholder="请选择开始时间">
      </el-date-picker>
      <el-date-picker
        size="medium"
        v-model="searchForm.endTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsEnd"
        placeholder="请选择结束时间">
      </el-date-picker>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
      <a :href="url+'/web/product/order/list/export?startTime='+searchForm.startTime + '&&endTime='+searchForm.endTime+'&&searchContent='+searchForm.searchContent+'&&miningStatus='+searchForm.miningStatus" style="margin-left:20px">
         <el-button size="medium" type="warning" icon="el-icon-folder-opened">导出</el-button>
      </a>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <!-- <el-table-column
      width="160"
      label="充币时间">
      <template slot-scope="scope">
        <span>{{$selfFunc.dayjsFunc(scope.row.doneTime)}}</span>
      </template>
    </el-table-column> -->
    <el-table-column
      prop="orderId"
      width="140px"
      label="订单号">
    </el-table-column>
    <el-table-column
      prop="useId"
      label="用户ID">
    </el-table-column>
    <el-table-column
      prop="phone"
      width="120px"
      label="手机号">
    </el-table-column>
    <el-table-column
      prop="email"
      width="200px"
      label="邮箱">
    </el-table-column>
    <el-table-column
      prop="productId"
      label="产品ID">
    </el-table-column>
    <el-table-column
      prop="productType"
      label="产品类型">
      <template slot-scope="scope">
        <span>{{scope.row.productType==1?'封装':scope.row.productType==2?'销售':scope.row.productType==4?'联合存储':'预售'}}</span>
      </template>
    </el-table-column>
    <el-table-column
      width="130px"
      prop="totalPower"
      label="订单存储数(TiB)">
    </el-table-column>
    <el-table-column
      width="100px"
      prop="totalIncome"
      label="总收益(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.filBalance,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="incomeFilAll"
      width="130px"
      label="已释放收益(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.incomeFilAll,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="filLocked"
      width="130px"
      label="待释放收益(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.filLocked,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="contract"
      width="120px"
      label="服务周期(day)">
    </el-table-column>
    <el-table-column
      prop="pledge"
      label="质押币">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.pledge,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="gas"
      label="Gas">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.gas,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="trus"
      label="托管费用">
    </el-table-column>
    <el-table-column
      prop="miningDay"
      width="110px"
      label="剩余服务天数">
    </el-table-column>
    <el-table-column
      prop="state"
      label="状态">
      <template slot-scope="scope">
        <span>{{scope.row.miningStatus==1?'服务中':scope.row.miningStatus==2?'待服务': '已结束'}}</span>
      </template>
    </el-table-column>
    <el-table-column
      width="160px"
      prop="orderTime"
      label="创建时间">
    </el-table-column>
    <el-table-column
      fixed="right"
      width="100px"
      label="操作">
      <template slot-scope="scope">
        <el-button size="mini" type="primary" @click="goDetl(scope.row.id)"><i class="el-icon-view" style="margin-right:3px;"></i>每日收益</el-button>
      </template>
    </el-table-column>
  </el-table>
  <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[16, 32, 50, 60]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var checkNum = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error('输入不能为空'));
      }else {
        if (value !=parseInt(value)) {
          callback(new Error('输入必须为正整数'));
        } else if (value < 0) {
          callback(new Error('输入不能为负值'));
        } else {
          callback();
        }
      }
    };
    var checkNum1 = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error("请输入正确的数值"));
      } else if (value <= 0) {
        callback("输入必须为正数");
      }else {
        callback()
      }
    };
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:16,
        searchContent: '',
        startTime: '',
        endTime: '',
        miningStatus: 0
      },
      tableData: [],
      options: [
        { name: "全部", value: 0 },
        { name: "服务中", value: 1 },
        { name: "待服务", value: 2 },
        { name: "已结束", value: 3 },
      ],
      userId: '',
      balance: 0,
      balanceTwo: 0,
      url: window.g.host
    };
  },
  created() {
    this.getTableList()
  },
  methods: {
    goDetl(id) {
      this.$router.push({name:'orderIncomeDaily',query:{orderId:id}})
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.orderCollectList({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          console.log(res.data)
          this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
